import React from "react";
import Page, {
  SECTION,
  HEADING,
  ROW,
  TEXT,
  CONTENT,
  CONTENT_LI,
} from "../components/Page";

import Testimonial from "../components/Testimonial";
import Polaroid from "../components/Polaroid";

const Home = () => (
  <Page>
    <ROW className="row">
      <section className="col-md-8 col-sm-12">
        <HEADING>
          Enterprise <TEXT>AppSec</TEXT> & <TEXT>Security Engineering</TEXT>
        </HEADING>

        <CONTENT>
          Hi, I'm Art 👋 a software engineer and security consultant
          with over 20 years of experience building and securing complex web
          applications, cloud architectures, and AI-enabled systems.
        </CONTENT>

        <CONTENT>
          I partner with CTOs and CISOs to accelerate compliance audits, unblock
          engineering velocity, and build resilient, security-first cloud
          architectures.
        </CONTENT>

        <CONTENT>
          🛡️ <strong>Strategic Security Advisory & Fractional CISO</strong>
          <br />
          🔍 <strong>Penetration Testing &amp; AI/LLM Security Assessment</strong>
          <br />
          ⚙️ <strong>Automated DevSecOps & CI/CD Security</strong>
          <br />
          🏗️{" "}
          <strong>Mission-Critical Cloud Defense (AWS, GCP, Azure)</strong>
        </CONTENT>

        <CONTENT>
          Stop security from being a bottleneck. Let’s integrate rigorous
          security controls that scale with your engineering team.
        </CONTENT>

        <CONTENT>
          <a className="btn btn-primary" href="/contact">
            <em>Schedule a Security Consultation</em>
          </a>
        </CONTENT>
      </section>

      <section className="col-md-4 col-sm-12">
        <Polaroid />
      </section>
    </ROW>

    <SECTION>
      <section>
        <hr />

        <HEADING>
          Scale with <TEXT>Confidence</TEXT> 🚀
        </HEADING>

        <CONTENT>
          Security shouldn't slow you down. I provide the high-level expertise
          needed to satisfy enterprise security requirements and clear the path
          for your engineering roadmap.
        </CONTENT>

        <ul>
          <CONTENT_LI>
            <strong>Accelerate Compliance:</strong> Prepare for and pass SOC2,
            HIPAA, or ISO 27001 audits with expert guidance.
          </CONTENT_LI>
          <CONTENT_LI>
            <strong>Threat Modeling:</strong> Proactively identify and mitigate
            architectural flaws before they reach production.
          </CONTENT_LI>
          <CONTENT_LI>
            <strong>Remediation Excellence:</strong> Receive precise, actionable engineering guidance -- not just a list of bugs -- to harden your codebase.
          </CONTENT_LI>
        </ul>

        <hr />
        
        <HEADING>
          Testimonials 🗣️
        </HEADING>

        <CONTENT>Here's what my customers say about me:</CONTENT>
      </section>
    </SECTION>

    <ROW className="row">
      <section className="col-md-4 col-sm-12">
        <Testimonial>
          <CONTENT>
            "Arthur provided critical expertise in the cyber security space as
            we launched our product. He was attentive to our needs and delivered
            high-quality results in a very timely manner.
          </CONTENT>

          <CONTENT>
            I highly recommend his consulting services and expect to work with
            him again in the future."
          </CONTENT>
        </Testimonial>
      </section>

      <section className="col-md-4 col-sm-12">
        <Testimonial>
          <CONTENT>
            "We hired Secure Web Solutions LLC to perform penetration testing on
            our system, and I found the process to be very smooth and highly
            professional from start to finish.
          </CONTENT>

          <CONTENT>
            The report we received was extremely thorough and they worked
            closely with us afterward to make sure we understood the results and
            how to address the issues found.
          </CONTENT>

          <CONTENT>I highly recommend their services."</CONTENT>
        </Testimonial>
      </section>

      <section className="col-md-4 col-sm-12">
        <Testimonial>
          <CONTENT>
            "Arthur had an amazing ability to juggle multiple projects and
            deliver on all of them. He was able to drop into our company and
            make an impact day one.
          </CONTENT>

          <CONTENT>
            He didn't need much supervision, and was always quick to reply to
            questions. He was very intelligent and brought thoughtful insights
            to design discussions.
          </CONTENT>

          <CONTENT>
            I think Arthur is a great engineer and I would love to work with him
            again in the future."
          </CONTENT>
        </Testimonial>
      </section>
    </ROW>

    <SECTION>
      <section>
        <CONTENT>Past customers include:</CONTENT>

        <img
          src="/img/customers/customer-logos.png"
          alt=""
          className="img-fluid"
        />
      </section>
    </SECTION>

    <SECTION>
      <section>
        <hr />

        <HEADING>
          I take security <span style={{ color: "#40b1e8" }}>seriously</span> 🔐{" "}
        </HEADING>

        <CONTENT>
          In today’s digital world, protecting your business is just as
          important as growing it.
        </CONTENT>

        <CONTENT>
          I bring a security-first mindset and hold multiple cybersecurity
          certifications to help keep your systems — and your customers — safe.
        </CONTENT>
      </section>
    </SECTION>

    <ROW
      className="row"
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
      }}
    >
      {[
        { src: "/img/icons/cissp-logo.png", alt: "ISC(2) CISSP" },
        { src: "/img/icons/CSAP.jpg", alt: "CompTIA CSAP" },
        { src: "/img/icons/CySA.png", alt: "CompTIA CySA+" },
        { src: "/img/icons/SecurityPlus.jpg", alt: "CompTIA Security+" },
        {
          src: "/img/icons/AWS-Certified_Cloud-Practitioner.png",
          alt: "AWS Cloud Practitioner",
        },
        {
          src: "/img/icons/AWS-Certified_Security_Specialty.png",
          alt: "AWS Security Specialty",
        },
      ].map(cert => (
        <div
          key={cert.alt}
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            borderRadius: "10px",
            width: "140px",
            height: "140px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
          }}
        >
          <img
            src={cert.src}
            alt={cert.alt}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      ))}
    </ROW>
  </Page>
);

export default Home;
